import { render, staticRenderFns } from "./DesignEditPanel.vue?vue&type=template&id=1b10ca6b&scoped=true"
import script from "./DesignEditPanel.vue?vue&type=script&lang=js"
export * from "./DesignEditPanel.vue?vue&type=script&lang=js"
import style0 from "./DesignEditPanel.vue?vue&type=style&index=0&id=1b10ca6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b10ca6b",
  null
  
)

export default component.exports